import { Component, inject, ViewEncapsulation } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageModule } from 'primeng/message';

@Component({
    selector: 'app-voice-recongnition-permissions',
    imports: [
        CommonModule,
        ButtonModule,
        DialogModule,
        MessageModule
    ],
    providers: [],
    templateUrl: './voice-recongnition-permissions.component.html',
    styleUrl: './voice-recongnition-permissions.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class VoiceRecongnitionPermissionsComponent {
  dynamicDialogRef = inject(DynamicDialogRef);
  dynamicDialogConfig = inject(DynamicDialogConfig);
  voiceRecognitionPermissionsStatus?: {speechRecognizerPermissionStatus: {status: string, canAskAgain: boolean, granted: boolean}, microphonePermissionStatus: {status: string, canAskAgain: boolean, granted: boolean}};

  constructor() {
    this.voiceRecognitionPermissionsStatus = this.dynamicDialogConfig.data;
    console.log('voiceRecognitionPermissionsStatus', this.voiceRecognitionPermissionsStatus)
  }

  goToSettings() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "open-settings", data: null}));
  }

  continueWithPermissions() {
    this.dynamicDialogRef.close(true);
  }

  closeDialog() {
    this.dynamicDialogRef.close(false);
  }

}
